import { render, staticRenderFns } from "./IndividualTable.vue?vue&type=template&id=06300d3c"
import script from "./IndividualTable.vue?vue&type=script&lang=js"
export * from "./IndividualTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports